var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.count),function(i){
var _obj;
return _c('div',{key:'skeleton' + i,staticClass:"skeleton-loading relative overflow-hidden",class:[_vm.color && ("bg-" + _vm.color), _vm.itemClass, ( _obj = {}, _obj[("mt-" + _vm.gap)] = i > 1, _obj ) ]})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }